import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { fuego } from '@nandorojo/swr-firestore';
import { CollectionPath } from '@typings/collections.enum';
import { PetInteractionLog } from '@typings/pets/pet.interface';
import { getJosaEuRo } from '@utils/josa';

export type ManualEvolveParams = {
  activePet: any;
  currentUid: string;
  petDocPath: string;
  evolutionOptions: Array<any>;
  levelKey: string;
};

export async function manualEvolve({ activePet, currentUid, petDocPath, evolutionOptions, levelKey, }: ManualEvolveParams) {
  if (!activePet || !currentUid || !petDocPath) return { ok: false, reason: 'invalid_params' };
  const available = (evolutionOptions || []).filter((o: any) => o && o.imgURL);
  if (available.length === 0) return { ok: false, reason: 'no_options' };

  const pick = available[Math.floor(Math.random() * available.length)];
  const prevURL = (activePet as any).customImgURL || '';
  const legacyEntry = prevURL ? { levelKey, imgURL: prevURL } : null;
  const updates: any = { customImgURL: pick.imgURL, updatedAt: new Date() };
  if (legacyEntry) {
    updates.legacyPetImgList = firebase.firestore.FieldValue.arrayUnion(legacyEntry);
  }
  await fuego.db.doc(petDocPath).set(updates, { merge: true } as any);
  await fuego.db.doc(petDocPath).set({ evolutionReadyFor: '', evolutionConsumedForLevels: firebase.firestore.FieldValue.arrayUnion(levelKey) } as any, { merge: true } as any);


  const petName = (activePet as any).customName || '펫';
  const stageName = pick?.name || '다음 단계';

  const josa = getJosaEuRo(stageName);
  const newLog: PetInteractionLog = {
    id: `evo_${Date.now()}`,
    userId: currentUid || '',
    petId: activePet.id,
    type: 'growth',
    message: `${petName}이 ${stageName}${josa} 진화했습니다!`,
    createdAt: new Date(),
  } as any;
  await fuego.db
    .collection(`${CollectionPath.USERS}/${currentUid}/pets/${activePet.id}/logs`)
    .add(newLog as any);

  return { ok: true, pick };
}


